/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveEpidemiologyCasePagedList } from '../models/ActiveEpidemiologyCasePagedList';
import type { ActiveEpidemiologyCasesSortBy } from '../models/ActiveEpidemiologyCasesSortBy';
import type { AddTreatmentPlanPrescribedTreatmentRequest } from '../models/AddTreatmentPlanPrescribedTreatmentRequest';
import type { AddTreatmentPlanPrescribedTreatmentResponse } from '../models/AddTreatmentPlanPrescribedTreatmentResponse';
import type { BirthType } from '../models/BirthType';
import type { CancelTreatmentPlanRequest } from '../models/CancelTreatmentPlanRequest';
import type { CancelTreatmentPlanResponse } from '../models/CancelTreatmentPlanResponse';
import type { CheckPregnancyHistoryResponse } from '../models/CheckPregnancyHistoryResponse';
import type { ConsultationSortBy } from '../models/ConsultationSortBy';
import type { CreateAccessRequestToEpidemiologyCaseRequest } from '../models/CreateAccessRequestToEpidemiologyCaseRequest';
import type { CreateBirthRequest } from '../models/CreateBirthRequest';
import type { CreateBirthResponse } from '../models/CreateBirthResponse';
import type { CreateConsultationExaminationRequest } from '../models/CreateConsultationExaminationRequest';
import type { CreateConsultationExaminationResponse } from '../models/CreateConsultationExaminationResponse';
import type { CreateConsultationInvestigationDemandLinkRequest } from '../models/CreateConsultationInvestigationDemandLinkRequest';
import type { CreateConsultationInvestigationDemandLinkResponse } from '../models/CreateConsultationInvestigationDemandLinkResponse';
import type { CreateConsultationRequest } from '../models/CreateConsultationRequest';
import type { CreateConsultationResponse } from '../models/CreateConsultationResponse';
import type { CreateConsultationTreatmentPlanRequest } from '../models/CreateConsultationTreatmentPlanRequest';
import type { CreateConsultationTreatmentPlanResponse } from '../models/CreateConsultationTreatmentPlanResponse';
import type { CreateEpidemiologyCaseRequest } from '../models/CreateEpidemiologyCaseRequest';
import type { CreateEpidemiologyCaseResponse } from '../models/CreateEpidemiologyCaseResponse';
import type { CreateHivAnamnesisCaseRequest } from '../models/CreateHivAnamnesisCaseRequest';
import type { CreateNewbornInvestigationRequest } from '../models/CreateNewbornInvestigationRequest';
import type { CreatePotentialContactRequest } from '../models/CreatePotentialContactRequest';
import type { CreatePotentialContactResponse } from '../models/CreatePotentialContactResponse';
import type { CreatePregnancyMonitoringInvestigationRequest } from '../models/CreatePregnancyMonitoringInvestigationRequest';
import type { CreatePregnancyMonitoringRequest } from '../models/CreatePregnancyMonitoringRequest';
import type { CreatePregnancyMonitoringResponse } from '../models/CreatePregnancyMonitoringResponse';
import type { CreateSidaCaseRequest } from '../models/CreateSidaCaseRequest';
import type { CreateSidaCaseResponse } from '../models/CreateSidaCaseResponse';
import type { CreateTreatmentPlanAdverseEffectEntryRequest } from '../models/CreateTreatmentPlanAdverseEffectEntryRequest';
import type { CreateTreatmentPlanAdverseEffectEntryResponse } from '../models/CreateTreatmentPlanAdverseEffectEntryResponse';
import type { CreateTreatmentPlanRecipeRequest } from '../models/CreateTreatmentPlanRecipeRequest';
import type { CreateTreatmentPlanRecipeResponse } from '../models/CreateTreatmentPlanRecipeResponse';
import type { DeletePotentialContactRequest } from '../models/DeletePotentialContactRequest';
import type { DispenseTreatmentPlanRecipeResponse } from '../models/DispenseTreatmentPlanRecipeResponse';
import type { EpidemiologyCaseAccessRequestPagedList } from '../models/EpidemiologyCaseAccessRequestPagedList';
import type { EpidemiologyCaseAccessRequestsSortBy } from '../models/EpidemiologyCaseAccessRequestsSortBy';
import type { EpidemiologyCaseAccessRequestStatus } from '../models/EpidemiologyCaseAccessRequestStatus';
import type { EpidemiologyCasePagedList } from '../models/EpidemiologyCasePagedList';
import type { EpidemiologyCasesSortBy } from '../models/EpidemiologyCasesSortBy';
import type { EpidemiologyCaseStatus } from '../models/EpidemiologyCaseStatus';
import type { FeedingType } from '../models/FeedingType';
import type { Gender } from '../models/Gender';
import type { GetCd4ContextResponse } from '../models/GetCd4ContextResponse';
import type { GetConsultationDiagnosesResponse } from '../models/GetConsultationDiagnosesResponse';
import type { GetConsultationInvestigationDemandListResponse } from '../models/GetConsultationInvestigationDemandListResponse';
import type { GetConsultationListResponse } from '../models/GetConsultationListResponse';
import type { GetConsultationResponse } from '../models/GetConsultationResponse';
import type { GetEpidemiologyCaseFormDraftResponse } from '../models/GetEpidemiologyCaseFormDraftResponse';
import type { GetEpidemiologyCaseResponse } from '../models/GetEpidemiologyCaseResponse';
import type { GetHivAnamnesisDoctorsResponse } from '../models/GetHivAnamnesisDoctorsResponse';
import type { GetHivAnamnesisPrefillResponse } from '../models/GetHivAnamnesisPrefillResponse';
import type { GetLastExaminationResponse } from '../models/GetLastExaminationResponse';
import type { GetListNewbornInvestigationResponse } from '../models/GetListNewbornInvestigationResponse';
import type { GetListPotentialContactResponse } from '../models/GetListPotentialContactResponse';
import type { GetListPregnancyMonitoringInvestigationsResponse } from '../models/GetListPregnancyMonitoringInvestigationsResponse';
import type { GetNewbornInvestigationStatusListResponse } from '../models/GetNewbornInvestigationStatusListResponse';
import type { GetPatientMedicalInstitutionResponse } from '../models/GetPatientMedicalInstitutionResponse';
import type { GetPotentialContactResponse } from '../models/GetPotentialContactResponse';
import type { GetPregnancyMonitoringListResponse } from '../models/GetPregnancyMonitoringListResponse';
import type { GetPregnancyMonitoringResponse } from '../models/GetPregnancyMonitoringResponse';
import type { GetSidaCaseResponse } from '../models/GetSidaCaseResponse';
import type { GetTbScreeningContextResponse } from '../models/GetTbScreeningContextResponse';
import type { GetTreatmentPlanAdverseEffectEntryListResponse } from '../models/GetTreatmentPlanAdverseEffectEntryListResponse';
import type { GetTreatmentPlanAdverseEffectEntryResponse } from '../models/GetTreatmentPlanAdverseEffectEntryResponse';
import type { GetTreatmentPlanListResponse } from '../models/GetTreatmentPlanListResponse';
import type { GetTreatmentPlanRecipeListResponse } from '../models/GetTreatmentPlanRecipeListResponse';
import type { GetTreatmentPlanRecipeResponse } from '../models/GetTreatmentPlanRecipeResponse';
import type { GetTreatmentPlanResponse } from '../models/GetTreatmentPlanResponse';
import type { HivAnamnesisCaseResponse } from '../models/HivAnamnesisCaseResponse';
import type { HivAnamnesisFormSection } from '../models/HivAnamnesisFormSection';
import type { InvestigationDemandSortBy } from '../models/InvestigationDemandSortBy';
import type { LatestConsultationResponse } from '../models/LatestConsultationResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { NewbornDto } from '../models/NewbornDto';
import type { NewbornInvestigationPeriod } from '../models/NewbornInvestigationPeriod';
import type { NewbornInvestigationSortBy } from '../models/NewbornInvestigationSortBy';
import type { NewbornPlanInvestigationStatus } from '../models/NewbornPlanInvestigationStatus';
import type { NewbornSortBy } from '../models/NewbornSortBy';
import type { NewBornStatus } from '../models/NewBornStatus';
import type { PatientBirthDto } from '../models/PatientBirthDto';
import type { PatientBirthSortBy } from '../models/PatientBirthSortBy';
import type { PregnancyMonitoringInvestigationSortBy } from '../models/PregnancyMonitoringInvestigationSortBy';
import type { PregnancyMonitoringPlanInvestigationStatus } from '../models/PregnancyMonitoringPlanInvestigationStatus';
import type { PregnancyMonitoringSortBy } from '../models/PregnancyMonitoringSortBy';
import type { PregnancyPeriod } from '../models/PregnancyPeriod';
import type { PregnancyPeriodType } from '../models/PregnancyPeriodType';
import type { PregnancyType } from '../models/PregnancyType';
import type { RecipeSortBy } from '../models/RecipeSortBy';
import type { RecipeStatus } from '../models/RecipeStatus';
import type { RecordHivAnamnesisAnnualUpdateRequest } from '../models/RecordHivAnamnesisAnnualUpdateRequest';
import type { RejectRequestToAccessEpidemiologyCaseRequest } from '../models/RejectRequestToAccessEpidemiologyCaseRequest';
import type { RescheduleConsultationRequest } from '../models/RescheduleConsultationRequest';
import type { RescheduleConsultationResponse } from '../models/RescheduleConsultationResponse';
import type { ScheduleConsultationRequest } from '../models/ScheduleConsultationRequest';
import type { ScheduleConsultationResponse } from '../models/ScheduleConsultationResponse';
import type { SearchPatientBirthQueryResponse } from '../models/SearchPatientBirthQueryResponse';
import type { SearchPatientNewbornsQueryResponse } from '../models/SearchPatientNewbornsQueryResponse';
import type { TreatmentPlanSortBy } from '../models/TreatmentPlanSortBy';
import type { UpdateConsultationExaminationRequest } from '../models/UpdateConsultationExaminationRequest';
import type { UpdateConsultationExaminationResponse } from '../models/UpdateConsultationExaminationResponse';
import type { UpdateConsultationRequest } from '../models/UpdateConsultationRequest';
import type { UpdateConsultationResponse } from '../models/UpdateConsultationResponse';
import type { UpdateEpidemiologyCaseRequest } from '../models/UpdateEpidemiologyCaseRequest';
import type { UpdateEpidemiologyCaseResponse } from '../models/UpdateEpidemiologyCaseResponse';
import type { UpdateHivAnamnesisCaseRequest } from '../models/UpdateHivAnamnesisCaseRequest';
import type { UpdatePregnancyMonitoringRequest } from '../models/UpdatePregnancyMonitoringRequest';
import type { UpdatePregnancyMonitoringResponse } from '../models/UpdatePregnancyMonitoringResponse';
import type { UpdateSidaCaseRequest } from '../models/UpdateSidaCaseRequest';
import type { UpdateSidaCaseResponse } from '../models/UpdateSidaCaseResponse';
import type { UpdateTreatmentPlanPrescribedTreatmentRequest } from '../models/UpdateTreatmentPlanPrescribedTreatmentRequest';
import type { UpdateTreatmentPlanPrescribedTreatmentResponse } from '../models/UpdateTreatmentPlanPrescribedTreatmentResponse';
import type { UpdateTreatmentPlanRequest } from '../models/UpdateTreatmentPlanRequest';
import type { UpdateTreatmentPlanResponse } from '../models/UpdateTreatmentPlanResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TreatmentService {
    /**
     * Updates a treatment plan.
     * Updates the treatment plan properties such as urgency, end date, and recommendations.
     * @param id Treatment plan identifier.
     * @param requestBody
     * @returns UpdateTreatmentPlanResponse The treatment plan has been updated successfully.
     * @throws ApiError
     */
    public static updateTreatmentPlanEndpoint(
        id: string,
        requestBody: UpdateTreatmentPlanRequest,
    ): CancelablePromise<UpdateTreatmentPlanResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/treatment-plans/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided or plan is in an invalid state.`,
                401: `User is not authorized.`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Gets treatment plan.
     * Gets treatment plan with details.
     * @param id Treatment plan identifier.
     * @returns GetTreatmentPlanResponse The treatment plan has been retrieved successfully.
     * @throws ApiError
     */
    public static getTreatmentPlanEndpoint(
        id: string,
    ): CancelablePromise<GetTreatmentPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment-plans/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan/associated consultations not found.`,
            },
        });
    }
    /**
     * Gets a list of recipes.
     * Gets a list of recipes.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param personId Filter by person identifier, optional.
     * @param treatmentPlanId Filter by treatment plan identifier, optional.
     * @param legalEntityId
     * @param dateIssued Filter by recipe issue date, optional.
     * @param dispensingDate Filter by date the prescribed drugs were dispensed, optional.
     * @param status Filter by recipe status, optional.
     * @param sortBy Sorting by date issued, dispensing date, optional.If no sort option is provided, the list will default to sorted by Created.
     * @param sortDirection Sort direction, default descending.
     * @param searchTerm
     * @returns GetTreatmentPlanRecipeListResponse Recipes have been retrieved successfully.
     * @throws ApiError
     */
    public static getTreatmentPlanRecipeListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        personId?: string | null,
        treatmentPlanId?: string | null,
        legalEntityId?: string | null,
        dateIssued?: string | null,
        dispensingDate?: string | null,
        status?: RecipeStatus | null,
        sortBy?: RecipeSortBy | null,
        sortDirection?: ListSortDirection | null,
        searchTerm?: string | null,
    ): CancelablePromise<GetTreatmentPlanRecipeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment-plans/recipes',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'personId': personId,
                'treatmentPlanId': treatmentPlanId,
                'legalEntityId': legalEntityId,
                'dateIssued': dateIssued,
                'dispensingDate': dispensingDate,
                'status': status,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Gets recipe.
     * Gets recipe for the current treatment plan.
     * @param id Treatment plan identifier.
     * @param recipeId Recipe identifier.
     * @returns GetTreatmentPlanRecipeResponse Recipe has been retrieved successfully.
     * @throws ApiError
     */
    public static getTreatmentPlanRecipeEndpoint(
        id: string,
        recipeId: string,
    ): CancelablePromise<GetTreatmentPlanRecipeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment-plans/{id}/recipes/{recipeId}',
            path: {
                'id': id,
                'recipeId': recipeId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `Treatment plan/recipe not found.`,
            },
        });
    }
    /**
     * Dispensing medication for a current recipe.
     * Dispensing medication for a current recipe.
     * @param treatmentPlanId
     * @param recipeId
     * @returns DispenseTreatmentPlanRecipeResponse The medication has been dispensed successfully.
     * @throws ApiError
     */
    public static dispenseTreatmentPlanRecipeEndpoint(
        treatmentPlanId: string,
        recipeId: string,
    ): CancelablePromise<DispenseTreatmentPlanRecipeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/treatment-plans/{treatmentPlanId}/recipes/{recipeId}/dispense',
            path: {
                'treatmentPlanId': treatmentPlanId,
                'recipeId': recipeId,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `Treatment plan/recipe not found.`,
            },
        });
    }
    /**
     * Declining to provide the medication without a valid recipe.
     * Declining to provide the medication without a valid recipe.
     * @param treatmentPlanId
     * @param recipeId
     * @returns DispenseTreatmentPlanRecipeResponse A successful refusal to provide a medication without a valid recipe.
     * @throws ApiError
     */
    public static declineTreatmentPlanRecipeEndpoint(
        treatmentPlanId: string,
        recipeId: string,
    ): CancelablePromise<DispenseTreatmentPlanRecipeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/treatment-plans/{treatmentPlanId}/recipes/{recipeId}/decline',
            path: {
                'treatmentPlanId': treatmentPlanId,
                'recipeId': recipeId,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan/recipe not found.`,
            },
        });
    }
    /**
     * Creates recipes.
     * Creates recipes for the current treatment plan.
     * @param id Treatment plan identifier.
     * @param requestBody
     * @returns CreateTreatmentPlanRecipeResponse Recipe has been created successfully.
     * @throws ApiError
     */
    public static createTreatmentPlanRecipeEndpoint(
        id: string,
        requestBody: CreateTreatmentPlanRecipeRequest,
    ): CancelablePromise<CreateTreatmentPlanRecipeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/treatment-plans/{id}/recipes',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Updates a prescribed treatment in a treatment plan.
     * Modifies an existing prescribed treatment (dose, schedule, dates) within a treatment plan.
     * @param id Treatment plan identifier.
     * @param ptId Prescribed treatment identifier.
     * @param requestBody
     * @returns UpdateTreatmentPlanPrescribedTreatmentResponse The prescribed treatment has been updated successfully.
     * @throws ApiError
     */
    public static updateTreatmentPlanPrescribedTreatmentEndpoint(
        id: string,
        ptId: string,
        requestBody: UpdateTreatmentPlanPrescribedTreatmentRequest,
    ): CancelablePromise<UpdateTreatmentPlanPrescribedTreatmentResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/treatment-plans/{id}/prescribed-treatments/{ptId}',
            path: {
                'id': id,
                'ptId': ptId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided or plan is in an invalid state.`,
                401: `User is not authorized.`,
                404: `Treatment plan or prescribed treatment not found.`,
            },
        });
    }
    /**
     * Removes a prescribed treatment from a treatment plan.
     * Deletes a prescribed treatment from a treatment plan. Cannot delete if the treatment has already been administered.
     * @param id Treatment plan identifier.
     * @param ptId Prescribed treatment identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteTreatmentPlanPrescribedTreatmentEndpoint(
        id: string,
        ptId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/treatment-plans/{id}/prescribed-treatments/{ptId}',
            path: {
                'id': id,
                'ptId': ptId,
            },
            errors: {
                400: `The prescribed treatment has already been administered.`,
                401: `User is not authorized.`,
                404: `Treatment plan or prescribed treatment not found.`,
            },
        });
    }
    /**
     * Adds a prescribed treatment to a treatment plan.
     * Adds a new prescribed treatment (medication) to an existing treatment plan.
     * @param id Treatment plan identifier.
     * @param requestBody
     * @returns AddTreatmentPlanPrescribedTreatmentResponse The prescribed treatment has been added successfully.
     * @throws ApiError
     */
    public static addTreatmentPlanPrescribedTreatmentEndpoint(
        id: string,
        requestBody: AddTreatmentPlanPrescribedTreatmentRequest,
    ): CancelablePromise<AddTreatmentPlanPrescribedTreatmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/treatment-plans/{id}/prescribed-treatments',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided or plan is in an invalid state.`,
                401: `User is not authorized.`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Gets a list of adverse effect entries.
     * Gets a list of adverse effect entries in the current treatment plan.
     * @param id Consultation identifier.
     * @returns GetTreatmentPlanAdverseEffectEntryListResponse Adverse effect entries have been retrieved successfully.
     * @throws ApiError
     */
    public static getTreatmentPlanAdverseEffectEntryListEndpoint(
        id: string,
    ): CancelablePromise<GetTreatmentPlanAdverseEffectEntryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment-plans/{id}/adverse-effect-entries',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates adverse effect entries.
     * Creates adverse effect entries in the current treatment plan.
     * @param id Treatment plan identifier.
     * @param requestBody
     * @returns CreateTreatmentPlanAdverseEffectEntryResponse Adverse effect entries have been created successfully.
     * @throws ApiError
     */
    public static createTreatmentPlanAdverseEffectEntryEndpoint(
        id: string,
        requestBody: CreateTreatmentPlanAdverseEffectEntryRequest,
    ): CancelablePromise<CreateTreatmentPlanAdverseEffectEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/treatment-plans/{id}/adverse-effect-entries',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Gets adverse effect entry.
     * Gets adverse effect entry for the current treatment plan.
     * @param id Treatment plan identifier.
     * @param adverseEffectEntryId Adverse effect entry identifier.
     * @returns GetTreatmentPlanAdverseEffectEntryResponse The adverse effect entry has been retrieved successfully.
     * @throws ApiError
     */
    public static getTreatmentPlanAdverseEffectEntryEndpoint(
        id: string,
        adverseEffectEntryId: string,
    ): CancelablePromise<GetTreatmentPlanAdverseEffectEntryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment-plans/{id}/adverse-effect-entries/{adverseEffectEntryId}',
            path: {
                'id': id,
                'adverseEffectEntryId': adverseEffectEntryId,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan/adverse effect entry not found.`,
            },
        });
    }
    /**
     * Gets a list of treatment plans.
     * Gets a list of treatment plans.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param personId Search by person identifier, optional.
     * @param legalEntityId
     * @param startDate Search by treatment start date, optional.
     * @param endDate Search by treatment end date, optional.
     * @param treatmentType Search by treatment type, optional. Partial search supported.
     * @param sortBy Sorting by start date, end date and treatment type taking into account Romanian and Russian languages, optional.
     * @param sortDirection Sort direction, default descending.
     * @returns GetTreatmentPlanListResponse Treatment plans have been retrieved successfully.
     * @throws ApiError
     */
    public static getTreatmentPlanListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        personId?: string | null,
        legalEntityId?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        treatmentType?: string | null,
        sortBy?: TreatmentPlanSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetTreatmentPlanListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment-plans',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'personId': personId,
                'legalEntityId': legalEntityId,
                'startDate': startDate,
                'endDate': endDate,
                'treatmentType': treatmentType,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Cancels treatment plan.
     * Cancels treatment plan due to some reason (patient has died or moved to another country etc).
     * @param id Treatment plan identifier.
     * @param requestBody
     * @returns CancelTreatmentPlanResponse The treatment plan has been cancelled successfully.
     * @throws ApiError
     */
    public static cancelTreatmentPlanEndpoint(
        id: string,
        requestBody: CancelTreatmentPlanRequest,
    ): CancelablePromise<CancelTreatmentPlanResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/treatment-plans/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Update a SIDA case.
     * Updates the SIDA stage establishment record (Form 058-2/e) for the specified case identifier.
     * @param id The unique identifier of the SIDA case to update.
     * @param requestBody
     * @returns UpdateSidaCaseResponse The SIDA case has been updated successfully.
     * @throws ApiError
     */
    public static updateSidaCaseEndpoint(
        id: string,
        requestBody: UpdateSidaCaseRequest,
    ): CancelablePromise<UpdateSidaCaseResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/sida-cases/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request parameters are invalid.`,
                401: `User is not authorized.`,
                404: `The SIDA case was not found.`,
            },
        });
    }
    /**
     * Delete a SIDA case.
     * Permanently removes the SIDA stage establishment record (Form 058-2/e) for the specified case identifier.
     * @param id The unique identifier of the SIDA case to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteSidaCaseEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/sida-cases/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The SIDA case was not found.`,
            },
        });
    }
    /**
     * Get SIDA case by person.
     * Retrieves the SIDA stage establishment record (Form 058-2/e) for the specified person.
     * @param personId The unique identifier of the person.
     * @returns GetSidaCaseResponse The SIDA case has been retrieved successfully.
     * @throws ApiError
     */
    public static getSidaCaseEndpoint(
        personId: string,
    ): CancelablePromise<GetSidaCaseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sida-cases/person/{personId}',
            path: {
                'personId': personId,
            },
            errors: {
                401: `User is not authorized.`,
                404: `No SIDA case found for this person.`,
            },
        });
    }
    /**
     * Create a SIDA case.
     * Creates a SIDA stage establishment record (Form 058-2/e) for a person. Only one record is allowed per person.
     * @param requestBody
     * @returns CreateSidaCaseResponse The SIDA case has been created successfully.
     * @throws ApiError
     */
    public static createSidaCaseEndpoint(
        requestBody: CreateSidaCaseRequest,
    ): CancelablePromise<CreateSidaCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/sida-cases',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request parameters are invalid.`,
                401: `User is not authorized.`,
                404: `The person was not found.`,
                409: `A SIDA case already exists for this person.`,
            },
        });
    }
    /**
     * Updates pregnancy monitoring.
     * Updates pregnancy monitoring with provided details.
     * @param id Unique identifier of the pregnancy monitoring record to update.
     * @param requestBody
     * @returns UpdatePregnancyMonitoringResponse Pregnancy monitoring has been updated successfully.
     * @throws ApiError
     */
    public static updatePregnancyMonitoringEndpoint(
        id: string,
        requestBody: UpdatePregnancyMonitoringRequest,
    ): CancelablePromise<UpdatePregnancyMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/pregnancy-monitoring/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Gets pregnancy monitoring.
     * Gets pregnancy monitoring with investigation demands.
     * @param id Unique identifier of the pregnancy monitoring record to retrieve
     * @returns GetPregnancyMonitoringResponse Pregnancy monitoring has been retrieved successfully.
     * @throws ApiError
     */
    public static getPregnancyMonitoringEndpoint(
        id: string,
    ): CancelablePromise<GetPregnancyMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `Pregnancy monitoring not found.`,
            },
        });
    }
    /**
     * Get the investigation completeness of the newborns.
     * One row per newborn (with an investigation plan) with the state of each investigation period: Done (an approved result exists), Requested (a demand without result), Missing (past due, nothing requested) or Planned (not due yet). A newborn is complete when every past-due period is Done. This endpoint requires the following permissions: [ Treatment.PregnancyMonitoringNewborn.View.Newborn/s ]
     * @param pageNumber Gets the page number. Defaults to 1.
     * @param pageSize Gets the page size. Defaults to 10.
     * @param searchTerm Filters by the name of the child or of the mother (also SIME code, TARV code or IDNP of either).
     * @param sortDirection The direction of the sort by birth date. Defaults to Descending (youngest first).
     * @param institutionIds Filters by the institution that registered the birth.
     * @param birthDateFrom Filters newborns born on or after this date.
     * @param birthDateTo Filters newborns born on or before this date.
     * @param onlyIncomplete Only newborns with at least one past-due period without an approved result
     * (only the Period when it is given).
     * @param period Only newborns that already reached this period (its due date passed). Combined with
     * OnlyIncomplete: only newborns that have no approved result for this period.
     * @returns GetNewbornInvestigationStatusListResponse Success
     * @throws ApiError
     */
    public static getNewbornInvestigationStatusListEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        institutionIds?: Array<string> | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
        onlyIncomplete?: boolean | null,
        period?: NewbornInvestigationPeriod | null,
    ): CancelablePromise<GetNewbornInvestigationStatusListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/newborns/investigation-status',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'institutionIds': institutionIds,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'onlyIncomplete': onlyIncomplete,
                'period': period,
            },
            errors: {
                401: `User is not authorized.`,
                403: `User does not have the required permissions.`,
            },
        });
    }
    /**
     * Get an filterable list of newborn investigations.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber Gets the page number. Defaults to 1.
     * @param ids Gets or sets the collection of newborn IDs to filter by.
     * @param pageSize Gets the optional page size.
     * @param searchTerm This property is used to filter items
     * containing strings matching the specified value.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * Defaults to Descending.
     * @param sortBy Specifies the property by which the items should be sorted.
     * Defaults to PeriodDate.
     * @param institutionIds Gets the collection of institution IDs to filter by.
     * @param personIds Gets the collection of person IDs to filter by.
     * @param pregnancyMonitoringIds Filter newborn planned investigations by newborn pregnancy monitoring ID.
     * @param newbornPeriod Gets the collection of investigation periods to filter by.
     * @param status Gets the collection of investigation statuses to filter by.
     * @param periodDateFrom Gets the start date to filter the period range.
     * @param periodDateTo Gets the end date to filter the period range.
     * @returns GetListNewbornInvestigationResponse Success
     * @throws ApiError
     */
    public static getListNewbornInvestigationEndpoint(
        pageNumber: number,
        ids: Array<string>,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        sortBy?: NewbornInvestigationSortBy | null,
        institutionIds?: Array<string> | null,
        personIds?: Array<string> | null,
        pregnancyMonitoringIds?: Array<string> | null,
        newbornPeriod?: Array<NewbornInvestigationPeriod> | null,
        status?: Array<NewbornPlanInvestigationStatus> | null,
        periodDateFrom?: string | null,
        periodDateTo?: string | null,
    ): CancelablePromise<GetListNewbornInvestigationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/newborns/investigation-demands',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'sortBy': sortBy,
                'ids': ids,
                'institutionIds': institutionIds,
                'personIds': personIds,
                'pregnancyMonitoringIds': pregnancyMonitoringIds,
                'newbornPeriod': newbornPeriod,
                'status': status,
                'periodDateFrom': periodDateFrom,
                'periodDateTo': periodDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a new investigation demand for a newborn.
     * This endpoint requires the following permissions: [  ]
     * @param id The unique identifier of the new born.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createNewbornInvestigationEndpoint(
        id: string,
        requestBody: CreateNewbornInvestigationRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pregnancy-monitoring/newborns/{id}/investigation-demands',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtains a paginated list of newborns.
     * This endpoint requires the following permissions: [ Treatment.PregnancyMonitoringNewborn.View.Newborn/s ]
     * @param pageNumber Gets the page number. Defaults to 1.
     * @param pageSize Gets the optional page size.
     * @param searchTerm This property is used to filter items
     * containing strings matching the specified value.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * Defaults to Descending.
     * @param sortBy Specifies the property by which the items should be sorted.
     * Defaults to BirthDate.
     * @param ids Gets or sets the collection of unique identifiers (IDs) for filtering the query.
     * @param personIds Gets or sets the collection of person identifiers to filter newborns by patient.
     * @param birthIds Gets or sets the collection of birth identifiers to filter newborns by birth record.
     * @param institutionIds Gets or sets the collection of institution identifiers to filter newborns by facility.
     * @param pregnancyMonitoringIds Gets or sets the collection of pregnancy monitoring identifiers to filter newborns by pregnancy monitoring record.
     * @param feedingType Gets or sets the collection of feeding types to filter by method of feeding.
     * @param status Gets or sets the collection of newborn statuses to filter by health condition.
     * @param birthDateFrom Gets or sets the start date for filtering newborns based on birthdate.
     * @param birthDateTo Gets or sets the end date for filtering newborns based on birthdate.
     * @returns SearchPatientNewbornsQueryResponse Success
     * @throws ApiError
     */
    public static getListPatientNewbornsEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        sortBy?: NewbornSortBy | null,
        ids?: Array<string> | null,
        personIds?: Array<string> | null,
        birthIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        pregnancyMonitoringIds?: Array<string> | null,
        feedingType?: Array<FeedingType> | null,
        status?: Array<NewBornStatus> | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
    ): CancelablePromise<SearchPatientNewbornsQueryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/newborns',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'sortBy': sortBy,
                'ids': ids,
                'personIds': personIds,
                'birthIds': birthIds,
                'institutionIds': institutionIds,
                'pregnancyMonitoringIds': pregnancyMonitoringIds,
                'feedingType': feedingType,
                'status': status,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtains newborn details by ID.
     * This endpoint requires the following permissions: [ Treatment.PregnancyMonitoringNewborn.View.Newborn/s ]
     * @param id Gets or initializes the unique identifier for the newborn request.
     * This property serves as a key for identifying the specific newborn record
     * within the pregnancy monitoring system.
     * @returns NewbornDto Success
     * @throws ApiError
     */
    public static getNewBornEndpoint(
        id: string,
    ): CancelablePromise<NewbornDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/newborns/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Gets an filterable list of treatment plan examination investigation demands.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber Gets the page number. Defaults to 1.
     * @param pageSize Gets the optional page size.
     * @param searchTerm This property is used to filter items
     * containing strings matching the specified value.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * Defaults to Descending.
     * @param sortBy Specifies the property by which the items should be sorted.
     * Defaults to PeriodDate.
     * @param ids Gets the unique identifier of the treatment plan examination.
     * @param institutionIds Gets the list of institution IDs to filter by.
     * @param personIds Gets the list of person IDs to filter by.
     * @param pregnancyPeriod Gets the list of pregnancy periods to filter by.
     * @param status Gets the list of investigation statuses to filter by.
     * @param periodDateFrom Gets the start date to filter the period range.
     * @param periodDateTo Gets the end date to filter the period range.
     * @returns GetListPregnancyMonitoringInvestigationsResponse Success
     * @throws ApiError
     */
    public static getListPregnancyMonitoringInvestigationsEndpoint(
        pageNumber: number,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        sortBy?: PregnancyMonitoringInvestigationSortBy | null,
        ids?: Array<string> | null,
        institutionIds?: Array<string> | null,
        personIds?: Array<string> | null,
        pregnancyPeriod?: Array<PregnancyPeriod> | null,
        status?: Array<PregnancyMonitoringPlanInvestigationStatus> | null,
        periodDateFrom?: string | null,
        periodDateTo?: string | null,
    ): CancelablePromise<GetListPregnancyMonitoringInvestigationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/investigation-demands',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'sortBy': sortBy,
                'ids': ids,
                'institutionIds': institutionIds,
                'personIds': personIds,
                'pregnancyPeriod': pregnancyPeriod,
                'status': status,
                'periodDateFrom': periodDateFrom,
                'periodDateTo': periodDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Creates a link between pregnancy monitoring and investigation demands.
     * @param id The unique identifier of the pregnancy monitoring.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createPregnancyMonitoringInvestigationEndpoint(
        id: string,
        requestBody: CreatePregnancyMonitoringInvestigationRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pregnancy-monitoring/{id}/investigation-demands',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The pregnancy monitoring has not been found.`,
            },
        });
    }
    /**
     * Gets a list of pregnancy monitoring.
     * Gets a list of pregnancy monitoring.
     * @param pageNumber Page number for pagination (default: 1)
     * @param pageSize Number of items per page (default: 10)
     * @param personId Optional filter by person ID
     * @param legalEntityId Optional filter by legal entity ID
     * @param lastMenstrualPeriod Optional filter by last menstrual period date
     * @param gestationalAgeInWeeks Optional filter by gestational age in weeks
     * @param expectedDateOfBirth Optional filter by expected date of birth
     * @param pregnancyType Optional filter by pregnancy type ID
     * @param sortBy Optional sort field
     * @param sortDirection Optional sort direction
     * @returns GetPregnancyMonitoringListResponse Pregnancy monitoring list has been retrieved successfully.
     * @throws ApiError
     */
    public static getPregnancyMonitoringListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        personId?: string | null,
        legalEntityId?: string | null,
        lastMenstrualPeriod?: string | null,
        gestationalAgeInWeeks?: number | null,
        expectedDateOfBirth?: string | null,
        pregnancyType?: PregnancyType | null,
        sortBy?: PregnancyMonitoringSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetPregnancyMonitoringListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'personId': personId,
                'legalEntityId': legalEntityId,
                'lastMenstrualPeriod': lastMenstrualPeriod,
                'gestationalAgeInWeeks': gestationalAgeInWeeks,
                'expectedDateOfBirth': expectedDateOfBirth,
                'pregnancyType': pregnancyType,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates pregnancy monitoring.
     * Creates pregnancy monitoring for the current consultation.
     * @param requestBody
     * @returns CreatePregnancyMonitoringResponse The consultation pregnancy monitoring has been created successfully.
     * @throws ApiError
     */
    public static createPregnancyMonitoringEndpoint(
        requestBody: CreatePregnancyMonitoringRequest,
    ): CancelablePromise<CreatePregnancyMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pregnancy-monitoring',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Checks if person has pregnancy monitoring
     * This endpoint requires the following permissions: [  ]
     * @param id
     * @returns CheckPregnancyHistoryResponse Success
     * @throws ApiError
     */
    public static checkPregnancyHistoryEndpoint(
        id: string,
    ): CancelablePromise<CheckPregnancyHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{id}/has-pregnancy-monitoring',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtains a paginated list of pregnancy births
     * This endpoint requires the following permissions: [ Treatment.PregnancyMonitoringBirth.View.Birth/s ]
     * @param pageNumber Gets the page number. Defaults to 1.
     * @param pageSize Gets the optional page size.
     * @param searchTerm This property is used to filter items
     * containing strings matching the specified value.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * Defaults to Descending.
     * @param sortBy Specifies the property by which the items should be sorted.
     * Defaults to CreateDate.
     * @param ids Gets or sets the collection of unique identifiers (IDs) for filtering the query.
     * @param personIds Gets or sets the collection of person identifiers to filter births by patient.
     * @param institutionIds Gets or sets the collection of institution identifiers to filter births by facility.
     * @param pregnancyMonitoringIds Gets or sets the collection of pregnancy monitoring identifiers to filter newborns by pregnancy monitoring record.
     * @param birthType Gets or sets the collection of birth types to filter by delivery method.
     * @param pregnancyPeriodType Gets or sets the collection of pregnancy types to filter by gestational age category.
     * @param createdAtFrom Gets or sets the minimum date and time for filtering births based on creation date.
     * @param createdAtTo Gets or sets the maximum date and time for filtering births based on creation date.
     * @param birthDateFrom Gets or sets the start date for filtering births based on actual birthdate.
     * @param birthDateTo Gets or sets the end date for filtering births based on actual birthdate.
     * @returns SearchPatientBirthQueryResponse Success
     * @throws ApiError
     */
    public static getPatientBirthListEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        sortBy?: PatientBirthSortBy | null,
        ids?: Array<string> | null,
        personIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        pregnancyMonitoringIds?: Array<string> | null,
        birthType?: Array<BirthType> | null,
        pregnancyPeriodType?: Array<PregnancyPeriodType> | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
    ): CancelablePromise<SearchPatientBirthQueryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/births',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'sortBy': sortBy,
                'ids': ids,
                'personIds': personIds,
                'institutionIds': institutionIds,
                'pregnancyMonitoringIds': pregnancyMonitoringIds,
                'birthType': birthType,
                'pregnancyPeriodType': pregnancyPeriodType,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Create a pregnancy birth.
     * This endpoint requires the following permissions: [ Treatment.PregnancyMonitoringBirth.Create.Birth ]
     * @param requestBody
     * @returns CreateBirthResponse Success
     * @throws ApiError
     */
    public static createBirthEndpoint(
        requestBody: CreateBirthRequest,
    ): CancelablePromise<CreateBirthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/pregnancy-monitoring/births',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtains pregnancy birth by ID.
     * This endpoint requires the following permissions: [ Treatment.PregnancyMonitoringBirth.View.Birth/s ]
     * @param id Gets or sets the unique identifier for an entity.
     * @returns PatientBirthDto Pregnancy birth has been retrieved successfully.
     * @throws ApiError
     */
    public static getBirthEndpoint(
        id: string,
    ): CancelablePromise<PatientBirthDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/pregnancy-monitoring/births/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Update the HIV epidemiological anamnesis (Form 058-1/e).
     * Updates a Form 058-1/e record. A draft is saved without validation unless complete = true. A completed form stays editable, but every save is validated and it cannot go back to draft. When the user has no access to personal data, the stored identifying data is kept.
     * @param id The unique identifier of the Form 058-1/e record.
     * @param requestBody
     * @returns HivAnamnesisCaseResponse The Form 058-1/e record has been updated successfully.
     * @throws ApiError
     */
    public static updateHivAnamnesisCaseEndpoint(
        id: string,
        requestBody: UpdateHivAnamnesisCaseRequest,
    ): CancelablePromise<HivAnamnesisCaseResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/hiv-anamnesis-cases/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request parameters are invalid, or the form is not valid.`,
                401: `User is not authorized.`,
                404: `The Form 058-1/e record was not found.`,
                409: `The form was changed by another user after it was loaded (version mismatch).`,
            },
        });
    }
    /**
     * Get a pre-filled HIV epidemiological anamnesis (Form 058-1/e) for a person.
     * Builds a Form 058-1/e from the data already in the system (person, investigations, treatment, pregnancy monitoring, consultations). Nothing is saved. Pass sections to refresh only some sections, e.g. ?sections=Clinical for the yearly update. Each prefilled field is listed in sources.
     * @param personId The unique identifier of the person.
     * @param sections Sections to prefill. Empty means all sections.
     * @returns GetHivAnamnesisPrefillResponse The pre-filled form.
     * @throws ApiError
     */
    public static getHivAnamnesisPrefillEndpoint(
        personId: string,
        sections: Array<HivAnamnesisFormSection>,
    ): CancelablePromise<GetHivAnamnesisPrefillResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiv-anamnesis-cases/person/{personId}/prefill',
            path: {
                'personId': personId,
            },
            query: {
                'sections': sections,
            },
            errors: {
                401: `User is not authorized.`,
                404: `The person was not found.`,
            },
        });
    }
    /**
     * Get the doctors of Form 058-1/e field 4.
     * The users with a role at the current institution, by name, to choose the doctor who collected and reported the data. The ids passed in ids are always included.
     * @param ids Users to include whatever the search, e.g. the saved doctor.
     * @param searchTerm Part of the first or last name.
     * @returns GetHivAnamnesisDoctorsResponse The doctors.
     * @throws ApiError
     */
    public static getHivAnamnesisDoctorsEndpoint(
        ids: Array<string>,
        searchTerm?: string | null,
    ): CancelablePromise<GetHivAnamnesisDoctorsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiv-anamnesis-cases/doctors',
            query: {
                'searchTerm': searchTerm,
                'ids': ids,
            },
            errors: {
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Get the HIV epidemiological anamnesis (Form 058-1/e) of a person.
     * Retrieves the Form 058-1/e record of the specified person. The patient's identifying data is hidden when the user has no access to personal data.
     * @param personId The unique identifier of the person.
     * @returns HivAnamnesisCaseResponse The Form 058-1/e record has been retrieved successfully.
     * @throws ApiError
     */
    public static getHivAnamnesisCaseEndpoint(
        personId: string,
    ): CancelablePromise<HivAnamnesisCaseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiv-anamnesis-cases/person/{personId}',
            path: {
                'personId': personId,
            },
            errors: {
                401: `User is not authorized.`,
                404: `No Form 058-1/e record found for this person.`,
            },
        });
    }
    /**
     * Create the HIV epidemiological anamnesis (Form 058-1/e) of a person.
     * Creates the Form 058-1/e record of a person. Only one record is allowed per person. With complete = false the form is saved as a draft without validation; with complete = true the whole form is validated and marked as completed.
     * @param requestBody
     * @returns HivAnamnesisCaseResponse The Form 058-1/e record has been created successfully.
     * @throws ApiError
     */
    public static createHivAnamnesisCaseEndpoint(
        requestBody: CreateHivAnamnesisCaseRequest,
    ): CancelablePromise<HivAnamnesisCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hiv-anamnesis-cases',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request parameters are invalid, or the form is not valid for completion.`,
                401: `User is not authorized.`,
                404: `The person was not found.`,
                409: `A Form 058-1/e record already exists for this person.`,
            },
        });
    }
    /**
     * Record the yearly ECDC update of the HIV epidemiological anamnesis (Form 058-1/e).
     * Replaces section F (clinical data) of a completed Form 058-1/e and stores a snapshot of it for the given year in form.annualUpdates. Recording the same year again replaces that year's snapshot. The whole form is validated.
     * @param id The unique identifier of the Form 058-1/e record.
     * @param requestBody
     * @returns HivAnamnesisCaseResponse The yearly update has been recorded.
     * @throws ApiError
     */
    public static recordHivAnamnesisAnnualUpdateEndpoint(
        id: string,
        requestBody: RecordHivAnamnesisAnnualUpdateRequest,
    ): CancelablePromise<HivAnamnesisCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hiv-anamnesis-cases/{id}/annual-updates',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The form is not completed, the year is not valid or the form is not valid.`,
                401: `User is not authorized.`,
                404: `The Form 058-1/e record was not found.`,
                409: `The form was changed by another user after it was loaded (version mismatch).`,
            },
        });
    }
    /**
     * Updates a consultation.
     * Updates a consultation with provided details.
     * @param id Consultation identifier.
     * @param requestBody
     * @returns UpdateConsultationResponse The consultation has been updated successfully.
     * @throws ApiError
     */
    public static updateConsultationEndpoint(
        id: string,
        requestBody: UpdateConsultationRequest,
    ): CancelablePromise<UpdateConsultationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/consultations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Consultation/treatment plan not found.`,
                409: `Consultation has already taken place.`,
            },
        });
    }
    /**
     * Gets a consultation.
     * Gets a consultation with details.
     * @param id Consultation identifier.
     * @returns GetConsultationResponse The consultation has been retrieved successfully.
     * @throws ApiError
     */
    public static getConsultationEndpoint(
        id: string,
    ): CancelablePromise<GetConsultationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The consultation has not been found.`,
            },
        });
    }
    /**
     * Deletes a consultation.
     * Deletes a consultation.
     * @param id Consultation identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteConsultationEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/consultations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Consultation not found.`,
                409: `Consultation has already taken place.`,
            },
        });
    }
    /**
     * @param personId
     * @returns GetTbScreeningContextResponse Success
     * @throws ApiError
     */
    public static getTbScreeningContextEndpoint(
        personId: string,
    ): CancelablePromise<GetTbScreeningContextResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/tb-screening/context',
            query: {
                'personId': personId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Schedules a consultation appointment.
     * Schedules a consultation appointment.
     * @param requestBody
     * @returns ScheduleConsultationResponse The consultation appointment has been scheduled successfully.
     * @throws ApiError
     */
    public static scheduleConsultationEndpoint(
        requestBody: ScheduleConsultationRequest,
    ): CancelablePromise<ScheduleConsultationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/schedule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Reschedules a consultation appointment.
     * Reschedules a consultation appointment.
     * @param id Consultation identifier.
     * @param requestBody
     * @returns RescheduleConsultationResponse The consultation appointment has been rescheduled successfully.
     * @throws ApiError
     */
    public static rescheduleConsultationEndpoint(
        id: string,
        requestBody: RescheduleConsultationRequest,
    ): CancelablePromise<RescheduleConsultationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/consultations/{id}/reschedule',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Consultation not found.`,
                409: `Consultation has already taken place.`,
            },
        });
    }
    /**
     * Gets a list of potential contacts.
     * Gets a list of potential contacts in term of Consultation.
     * Required permission : Treatment.Consultation.ViewPotentialContacts.Institution
     * @param consultationId
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @returns GetListPotentialContactResponse Potential contacts have been retrieved successfully.
     * @throws ApiError
     */
    public static getListPotentialContactEndpoint(
        consultationId: string,
        pageNumber: number,
        pageSize: number,
    ): CancelablePromise<GetListPotentialContactResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/{consultationId}/potential-contacts',
            path: {
                'consultationId': consultationId,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Create potential contacts.
     * Create contacts in term of Consultation.
     * Required permission : Treatment.Consultation.CreatePotentialContacts.Institution
     * @param consultationId
     * @param requestBody
     * @returns CreatePotentialContactResponse Potential contact has been created successfully.
     * @throws ApiError
     */
    public static createPotentialContactEndpoint(
        consultationId: string,
        requestBody: CreatePotentialContactRequest,
    ): CancelablePromise<CreatePotentialContactResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/{consultationId}/potential-contacts',
            path: {
                'consultationId': consultationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get potential contacts.
     * Get contacts in term of Consultation.
     * Required permission : Treatment.Consultation.ViewPotentialContacts.Institution
     * @param consultationId
     * @param potentialContactId
     * @returns GetPotentialContactResponse Potential contact has been retrieved successfully.
     * @throws ApiError
     */
    public static getPotentialContactEndpoint(
        consultationId: string,
        potentialContactId: string,
    ): CancelablePromise<GetPotentialContactResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/{consultationId}/potential-contacts/{potentialContactId}',
            path: {
                'consultationId': consultationId,
                'potentialContactId': potentialContactId,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Delete potential contacts.
     * Delete contacts in term of Consultation.
     * Required permission : Treatment.Consultation.CreatePotentialContacts.Institution
     * @param consultationId
     * @param potentialContactId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static deletePotentialContactEndpoint(
        consultationId: string,
        potentialContactId: string,
        requestBody: DeletePotentialContactRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/consultations/{consultationId}/potential-contacts/{potentialContactId}',
            path: {
                'consultationId': consultationId,
                'potentialContactId': potentialContactId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Gets the latest consultation.
     * Gets the latest person consultation.
     * @param personId
     * @returns LatestConsultationResponse The latest person consultation has been retrieved successfully.
     * @throws ApiError
     */
    public static latestConsultationEndpoint(
        personId?: string | null,
    ): CancelablePromise<LatestConsultationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/latest',
            query: {
                'personId': personId,
            },
            errors: {
                401: `User is not authorized.`,
                404: `Consultation not found.`,
            },
        });
    }
    /**
     * Gets a list of consultations.
     * Gets a list of consultations.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param personId Search by person identifier, optional.
     * @param consultationDate Search by consultation date, optional.
     * @param legalEntityName Search by legal entity name, optional. Partial search support.
     * @param legalEntityId
     * @param sortBy Sorting by consultation date, by institution name, by consultation type, taking into account Romanian and Russian languages, optional.
     * @param sortDirection Sort direction, default descending.
     * @returns GetConsultationListResponse Consultations have been retrieved successfully.
     * @throws ApiError
     */
    public static getConsultationListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        personId?: string | null,
        consultationDate?: string | null,
        legalEntityName?: string | null,
        legalEntityId?: string | null,
        sortBy?: ConsultationSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetConsultationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'personId': personId,
                'consultationDate': consultationDate,
                'legalEntityName': legalEntityName,
                'legalEntityId': legalEntityId,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a consultation.
     * Creates a consultation.
     * @param requestBody
     * @returns CreateConsultationResponse The consultation has been created successfully.
     * @throws ApiError
     */
    public static createConsultationEndpoint(
        requestBody: CreateConsultationRequest,
    ): CancelablePromise<CreateConsultationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Treatment plan not found.`,
            },
        });
    }
    /**
     * Update a consultation examination.
     * Replaces the form of an existing examination of a consultation that can still be edited.
     * @param id Gets or sets the unique identifier of the examination.
     * @param requestBody
     * @returns UpdateConsultationExaminationResponse The details of the updated examination.
     * @throws ApiError
     */
    public static updateConsultationExaminationEndpoint(
        id: string,
        requestBody: UpdateConsultationExaminationRequest,
    ): CancelablePromise<UpdateConsultationExaminationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/consultations/examinations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The form is not valid or the consultation can no longer be edited.`,
                401: `User is not authorized.`,
                404: `The examination has not been found.`,
            },
        });
    }
    /**
     * Retrieves the details of the most recent examination for a given consultation.
     * This endpoint returns the latest examination information.
     * @param consultationId Gets or sets the unique identifier of the consultation.
     * @returns GetLastExaminationResponse The details of the most recent examination.
     * @throws ApiError
     */
    public static getLastExaminationEndpoint(
        consultationId: string,
    ): CancelablePromise<GetLastExaminationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/{consultationId}/examinations/last',
            path: {
                'consultationId': consultationId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The consultation has not been found.`,
            },
        });
    }
    /**
     * Create a new consultation examination.
     * Creates a new examination for a specific consultation.
     * @param requestBody
     * @returns CreateConsultationExaminationResponse The details of the created examination.
     * @throws ApiError
     */
    public static createConsultationExaminationEndpoint(
        requestBody: CreateConsultationExaminationRequest,
    ): CancelablePromise<CreateConsultationExaminationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/examinations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The consultation has not been found.`,
            },
        });
    }
    /**
     * Update a epidemiology case.
     * Update a epidemiology case.
     * @param id The unique identifier of the epidemiology case.
     * @param requestBody
     * @returns UpdateEpidemiologyCaseResponse The epidemiology case.
     * @throws ApiError
     */
    public static updateEpidemiologyCaseEndpoint(
        id: string,
        requestBody: UpdateEpidemiologyCaseRequest,
    ): CancelablePromise<UpdateEpidemiologyCaseResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/consultations/epidemiology-cases/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get details of an epidemiology case.
     * Get the epidemiology case details based on the provided case identifier.
     * @param id The ID of the epidemiology case to retrieve.
     * @returns GetEpidemiologyCaseResponse The epidemiology case has been retrieved successfully.
     * @throws ApiError
     */
    public static getEpidemiologyCaseEndpoint(
        id: string,
    ): CancelablePromise<GetEpidemiologyCaseResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/epidemiology-cases/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The consultation has not been found.`,
            },
        });
    }
    /**
     * Synchronizes the epidemiology case with external system SBTESP.
     * Synchronizes the epidemiology case with external system SBTESP.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static synchroniseEpidemiologyCaseEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/epidemiology-cases/{id}/synchronize',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The epidemiology case has not been found.`,
            },
        });
    }
    /**
     * Get medical institutions where the patient is served.
     * Get medical institutions where the patient is served.
     * @param classifierElementId Represents the identifier for a medical institution classifier element.
     * @returns GetPatientMedicalInstitutionResponse The medical institutions successfully retrieved.
     * @throws ApiError
     */
    public static getPatientMedicalInstitutionEndpoint(
        classifierElementId: string,
    ): CancelablePromise<GetPatientMedicalInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/epidemiology-cases/medical-institutions/{classifierElementId}',
            path: {
                'classifierElementId': classifierElementId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get paginated list of active epidemiology cases.
     * Get paginated list of active epidemiology cases.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm
     * @param sortBy
     * @param sortDirection
     * @param patientGender
     * @param patientBirthDateFrom
     * @param patientBirthDateTo
     * @param institutionId
     * @param createdAtFrom
     * @param createdAtTo
     * @returns ActiveEpidemiologyCasePagedList The paginated list of active epidemiology cases.
     * @throws ApiError
     */
    public static getActiveList(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        sortBy?: ActiveEpidemiologyCasesSortBy | null,
        sortDirection?: ListSortDirection | null,
        patientGender?: Gender | null,
        patientBirthDateFrom?: string | null,
        patientBirthDateTo?: string | null,
        institutionId?: string | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
    ): CancelablePromise<ActiveEpidemiologyCasePagedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/epidemiology-cases/active',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'patientGender': patientGender,
                'patientBirthDateFrom': patientBirthDateFrom,
                'patientBirthDateTo': patientBirthDateTo,
                'institutionId': institutionId,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Get paginated list of epidemiology cases.
     * Get paginated list of epidemiology cases.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm
     * @param patientId
     * @param patientGender
     * @param patientBirthDateFrom
     * @param patientBirthDateTo
     * @param institutionId
     * @param consultationId
     * @param status
     * @param createdAtFrom
     * @param createdAtTo
     * @param synchronisedAtFrom
     * @param synchronisedAtTo
     * @param sortBy
     * @param sortDirection
     * @returns EpidemiologyCasePagedList The paginated list of epidemiology cases.
     * @throws ApiError
     */
    public static getEpidemiologyCaseListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        patientId?: string | null,
        patientGender?: Gender | null,
        patientBirthDateFrom?: string | null,
        patientBirthDateTo?: string | null,
        institutionId?: string | null,
        consultationId?: string | null,
        status?: EpidemiologyCaseStatus | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
        synchronisedAtFrom?: string | null,
        synchronisedAtTo?: string | null,
        sortBy?: EpidemiologyCasesSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<EpidemiologyCasePagedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/epidemiology-cases',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'patientId': patientId,
                'patientGender': patientGender,
                'patientBirthDateFrom': patientBirthDateFrom,
                'patientBirthDateTo': patientBirthDateTo,
                'institutionId': institutionId,
                'consultationId': consultationId,
                'status': status,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'synchronisedAtFrom': synchronisedAtFrom,
                'synchronisedAtTo': synchronisedAtTo,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Get draft for initializing a new epidemiology case form.
     * Get draft for initializing a new epidemiology case form for the given consultation.
     * @param consultationId Identifier of the consultation.
     * @returns GetEpidemiologyCaseFormDraftResponse The draft has been retrieved and saved successfully.
     * @throws ApiError
     */
    public static getEpidemiologyCaseFormDraftEndpoint(
        consultationId: string,
    ): CancelablePromise<GetEpidemiologyCaseFormDraftResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/{consultationId}/epidemiology-cases/draft',
            path: {
                'consultationId': consultationId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The consultation has not been found.`,
            },
        });
    }
    /**
     * Create an epidemiology case without a consultation.
     * Creates an epidemiology case directly, supplying all clinical data inline instead of deriving it from an existing consultation.
     * @param requestBody
     * @returns CreateEpidemiologyCaseResponse The epidemiology case was created successfully.
     * @throws ApiError
     */
    public static createEpidemiologyCaseEndpoint(
        requestBody: CreateEpidemiologyCaseRequest,
    ): CancelablePromise<CreateEpidemiologyCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/epidemiology-cases',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request parameters are invalid.`,
                401: `User is not authorized.`,
                404: `The person was not found.`,
            },
        });
    }
    /**
     * Reject a access request to epidemiology case.
     * This endpoint requires the following permissions: [ Treatment.EpidemiologyCase.ManageRequest.All ]
     * @param id The ID of the epidemiology case to reject.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectRequest(
        id: string,
        requestBody: RejectRequestToAccessEpidemiologyCaseRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/epidemiology-cases/access-requests/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The access request has not been found.`,
            },
        });
    }
    /**
     * Get paginated list of access requests to epidemiology cases.
     * This endpoint requires the following permissions: [ Treatment.EpidemiologyCase.ViewRequest.All ]
     * @param pageNumber The page number for the requested data. Default is 1.
     * @param pageSize The number of records per page. Default is 10.
     * @param searchTerm Search term to match against access requests properties.
     * Search by:
     * Epidemiology case QR code,
     * Patient Sime code.
     * Patient Tarv code.
     * Patient Locality CUATM code.
     * @param sortBy Sort by a specific field in the access requests.
     * Default is sorted by creation date time.
     * @param sortDirection Specify the sort direction. Default is descending.
     * @param userId Identifier of the user who sent the access request.
     * @param epidemiologyCaseId Filter by identifier of the epidemiology case.
     * @param status Filter by the status of the access request.
     * @param createdAtFrom Filter requests created on or after this date.
     * @param createdAtTo Filter requests created on or before this date.
     * @param updatedAtFrom Filter requests updated on or after this date.
     * @param updatedAtTo Filter requests updated on or before this date.
     * @param patientId Filter by the associated patient's identifier, if any.
     * @param institutionId Filter by the associated institution's identifier, if any.
     * @returns EpidemiologyCaseAccessRequestPagedList The paginated list of access requests.
     * @throws ApiError
     */
    public static getAccessRequestsListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        sortBy?: EpidemiologyCaseAccessRequestsSortBy | null,
        sortDirection?: ListSortDirection | null,
        userId?: string | null,
        epidemiologyCaseId?: string | null,
        status?: EpidemiologyCaseAccessRequestStatus | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
        updatedAtFrom?: string | null,
        updatedAtTo?: string | null,
        patientId?: string | null,
        institutionId?: string | null,
    ): CancelablePromise<EpidemiologyCaseAccessRequestPagedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/epidemiology-cases/access-requests',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'userId': userId,
                'epidemiologyCaseId': epidemiologyCaseId,
                'status': status,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'updatedAtFrom': updatedAtFrom,
                'updatedAtTo': updatedAtTo,
                'patientId': patientId,
                'institutionId': institutionId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates an access request for an epidemiology case.
     * This endpoint requires the following permissions: [ Treatment.EpidemiologyCase.AddRequest.All ]
     * @param caseId The unique identifier of the epidemiology case.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createAccessRequestToEpidemiologyCaseEndpoint(
        caseId: string,
        requestBody: CreateAccessRequestToEpidemiologyCaseRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/epidemiology-cases/{caseId}/access-requests',
            path: {
                'caseId': caseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The epidemiology case was not been found.`,
            },
        });
    }
    /**
     * Accept a access request to epidemiology case.
     * This endpoint requires the following permissions: [ Treatment.EpidemiologyCase.ManageRequest.All ]
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static acceptRequestToAccessEpidemiologyCaseEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/epidemiology-cases/access-requests/{id}/accept',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The access request has not been found.`,
            },
        });
    }
    /**
     * The diagnosis history of a person: the diagnoses (and opportunistic diseases) recorded at each performed
     * consultation that has any, newest first. Preliminary diagnoses are only present on older consultations.
     * @param personId
     * @param pageNumber
     * @param pageSize
     * @returns GetConsultationDiagnosesResponse Success
     * @throws ApiError
     */
    public static getConsultationDiagnosesEndpoint(
        personId: string,
        pageNumber: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<GetConsultationDiagnosesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/diagnoses',
            query: {
                'personId': personId,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates treatment plan.
     * Creates treatment plan for the current consultation.
     * @param id The consultation identifier for which the treatment plan will be created.
     * @param requestBody
     * @returns CreateConsultationTreatmentPlanResponse The consultation treatment plan has been created successfully.
     * @throws ApiError
     */
    public static createConsultationTreatmentPlanEndpoint(
        id: string,
        requestBody: CreateConsultationTreatmentPlanRequest,
    ): CancelablePromise<CreateConsultationTreatmentPlanResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/{id}/treatment-plan',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Consultation not found.`,
                409: `The consultation already has treatment plan.`,
            },
        });
    }
    /**
     * Gets a list of investigation demands.
     * Gets a list of investigation demands for the current investigation.
     * @param id
     * @param sortBy
     * @param sortDirection
     * @returns GetConsultationInvestigationDemandListResponse Investigation demands have been retrieved successfully.
     * @throws ApiError
     */
    public static getConsultationInvestigationDemandListEndpoint(
        id: string,
        sortBy?: InvestigationDemandSortBy | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetConsultationInvestigationDemandListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/{id}/investigation-demands',
            path: {
                'id': id,
            },
            query: {
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a link between consultation and investigation demands.
     * Creates a link between consultation and investigation demands.
     * @param id Consultation identifier, to which the investigation demands are linked.
     * @param requestBody
     * @returns CreateConsultationInvestigationDemandLinkResponse The links between consultation and investigation demand have been established successfully.
     * @throws ApiError
     */
    public static createConsultationInvestigationDemandLinkEndpoint(
        id: string,
        requestBody: CreateConsultationInvestigationDemandLinkRequest,
    ): CancelablePromise<CreateConsultationInvestigationDemandLinkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/consultations/{id}/investigation-demand-links',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Consultation not found.`,
            },
        });
    }
    /**
     * @param personId
     * @returns GetCd4ContextResponse Success
     * @throws ApiError
     */
    public static getCd4ContextEndpoint(
        personId: string,
    ): CancelablePromise<GetCd4ContextResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/consultations/cd4-context',
            query: {
                'personId': personId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
